import type { SearchContext } from '@shared/types/types';
import { EXPERIMENTS } from '@tilelist/domain/experiments/Experiments.ts';
import type { OnEx } from '@tilelist/domain/experiments/OnEx.ts';

/**
 *
 *
 */
const ASSORTMENTS_WITH_TOP_INFO = [
    'Haushaltsgeräte',
    'Unterhaltungselektronik',
    'Optik',
    'Kommunikation',
    'Reinigungsgeräte',
    'Klima',
    'Bürotechnik',
] as const;

/**
 *
 *
 */
const ADDITIONAL_ASSORTMENTS = [
    'Gartengeräte',
    'Sportausrüstung',
    'Fahrzeuge',
    'Zahnpflege',
    'Haarstyling',
    'Haarentfernung',
    'Spielzeug',
    'Heizen',
    'Sonnenschutz',
    'Elektroinstallation',
    'Werkzeug',
    'Technik-Zubehör',
] as const;

const ASSORTMENTS_SET = new Set(ASSORTMENTS_WITH_TOP_INFO.map((item) => item.toLowerCase()));
const ADDITIONAL_SET = new Set(ADDITIONAL_ASSORTMENTS.map((item) => item.toLowerCase()));

function normalizeAssortment(searchContext: SearchContext | undefined): string | undefined {
    const assortment = searchContext?.assortment;
    return assortment ? assortment.toLowerCase() : undefined;
}

export function shouldShowTopInfos(searchContext: SearchContext | undefined, experimentService: OnEx): boolean {
    const normalized = normalizeAssortment(searchContext);
    if (!normalized) return false;

    const isBaseAssortment = ASSORTMENTS_SET.has(normalized);
    if (isBaseAssortment) return true;

    const isExperimentAssortment = ADDITIONAL_SET.has(normalized);
    const isInTestGroup = experimentService.isExperimentGroup(
        'ADDITIONAL_ASSORTMENTS_FOR_TOP_INFOS',
        EXPERIMENTS.ADDITIONAL_ASSORTMENTS_FOR_TOP_INFOS.featureOnGroup,
    );
    return isExperimentAssortment && isInTestGroup;
}

/**
 *
 */
export function isInExperiment(searchContext: SearchContext | undefined, experimentService: OnEx): boolean {
    const normalized = normalizeAssortment(searchContext);
    if (!normalized) return false;

    const isBaseAssortment = ASSORTMENTS_SET.has(normalized);
    if (isBaseAssortment) return false;

    const isExperimentAssortment = ADDITIONAL_SET.has(normalized);
    const isExperimentActive = experimentService.isExperimentActive('ADDITIONAL_ASSORTMENTS_FOR_TOP_INFOS');
    return isExperimentAssortment && isExperimentActive;
}
